import { sectionType } from '@/views/website/products/components/description/common/types';

export const IDENTIFIER_TAGS = {
  title: 'title',
  description: 'description',
  //   listItemCollapsible: 'listItemCollapsible',
};

export default {
  crawlType: 'faq_accordion',
  matchTemplates: [
    {
      type: sectionType.sectionFaqGrid03,
      tags: [IDENTIFIER_TAGS.title, IDENTIFIER_TAGS.description],
      priority: 1,
    },
    {
      type: sectionType.sectionFaqGrid04,
      tags: [IDENTIFIER_TAGS.title, IDENTIFIER_TAGS.description],
      priority: 2,
    },
  ],
};
